import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { AttributesActions } from './attributes.actions';
import { AsyncActions } from './attributes.actions';
import { Attribute } from '@emm/core/models/attribute.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const attributesFeatureKey = 'attributes';

export interface AttributeState extends EntityState<Attribute>, AsyncActionState {}

export const adapter: EntityAdapter<Attribute> = createEntityAdapter<Attribute>({
    selectId: (item: Attribute) => item.tag,
    sortComparer: null
});

export const initialState: AttributeState = adapter.getInitialState({
    ...asyncActionState.initial
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const attributeReducer = withLoadables<AttributeState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,
    on(AttributesActions.loadAllSuccess,
        (state: AttributeState, { attributes }) => adapter.setAll(attributes, state))
);
